import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Constants } from '@app/common/constants';
import { HttpHelper } from '@app/common/http-helper';
import { CacheService } from '@app/services/cache.service';
import { SharedInsight, Trending, UsedInsight } from '@microsoft/microsoft-graph-types-beta';
import { concat, Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MyDocumentsService {

  constructor(private http: HttpClient, private cache: CacheService, private httpHelper: HttpHelper) { }

  private readonly cacheKeyPrefix = 'MyDocumentsService';

  public useCache = true;

  getMyRecentDocuments(top: number): Observable<Array<UsedInsight>> {
    const httpParamsMyRecentDocuments = new HttpParams()
      .append('$top', top.toString())
      .append('$orderby', 'lastUsed/lastAccessedDateTime desc')
      .append('$filter', 'resourceVisualization/type ne \'spsite\' AND resourceVisualization/type ne \'Web\'');

    const cacheKey = `${this.cacheKeyPrefix}-getMyRecentDocuments-${top ? top.toString() : ''}`;

    const fetchOperation = this.http.get<any>(`${Constants.GRAPH_API_ENDPOINT + Constants.GRAPH_API_VERSION_ONE}/me/insights/used`,
      { params: httpParamsMyRecentDocuments })
      .pipe(
        map(response => {
          console.log(`fetched result: my recent documents: `, response);
          return response.value as Array<UsedInsight>;
        }),
        tap(data => {
          this.useCache && this.cache.set(cacheKey, data);
        }),
        catchError(this.httpHelper.handleError({ operation: 'getMyRecentDocuments', result: new Array<UsedInsight>(), cacheKey: cacheKey })));

    if (this.useCache) {
      const cachedData = this.cache.get<Array<UsedInsight>>(cacheKey);
      if (cachedData) {
        return concat(of(cachedData), fetchOperation);
      }
    }
    return fetchOperation;
  }

  getMyTrendingDocuments(top: number): Observable<Array<Trending>> {
    const httpParams = new HttpParams()
      .append('$top', top.toString())
      .append('$filter', 'resourceVisualization/type ne \'spsite\' AND resourceVisualization/type ne \'Web\'');

    const cacheKey = `${this.cacheKeyPrefix}-getMyTrendingDocuments-${top ? top.toString() : ''}`;

    const fetchOperation = this.http.get<any>(`${Constants.GRAPH_API_ENDPOINT + Constants.GRAPH_API_VERSION_ONE}/me/insights/trending`,
      { params: httpParams })
      .pipe(
        map(response => {
          console.log(`fetched result: my trending documents: `);
          console.log(response);
          return response.value as Array<Trending>;
        }),
        tap(data => {
          this.useCache && this.cache.set(cacheKey, data);
        }),
        catchError(this.httpHelper.handleError({ operation: 'getMyTrendingDocuments', result: new Array<Trending>(), cacheKey: cacheKey })));

    if (this.useCache) {
      const cachedData = this.cache.get<Array<Trending>>(cacheKey);
      if (cachedData) {
        return concat(of(cachedData), fetchOperation);
      }
    }
    return fetchOperation;
  }

  getMySharedDocuments(top: number): Observable<Array<SharedInsight>> {
    const httpParams = new HttpParams()
      .append('$top', top.toString())
      .append('$filter', 'resourceVisualization/type ne \'spsite\' AND resourceVisualization/type ne \'Web\'');

    const cacheKey = `${this.cacheKeyPrefix}-getMySharedDocuments-${top ? top.toString() : ''}`;

    const fetchOperation = this.http.get<any>(`${Constants.GRAPH_API_ENDPOINT + Constants.GRAPH_API_VERSION_ONE}/me/insights/shared`,
      { params: httpParams })
      .pipe(
        map(response => {
          console.log(`fetched result: my shared documents: `);
          console.log(response);
          return response.value as Array<SharedInsight>;
        }),
        tap(data => {
          this.useCache && this.cache.set(cacheKey, data);
        }),
        catchError(this.httpHelper.handleError({ operation: 'getMySharedDocuments', result: new Array<SharedInsight>(), cacheKey: cacheKey })));

    if (this.useCache) {
      const cachedData = this.cache.get<Array<SharedInsight>>(cacheKey);
      if (cachedData) {
        return concat(of(cachedData), fetchOperation);
      }
    }
    return fetchOperation;
  }
}
